<template>
  <slot :primary-media="primaryMedia" :secondary-media="secondaryMedia" />
</template>

<script>
export default {
  name: "ProductCardHelper",
  props: {
    imageType: {
      type: String,
      default: "default",
    },
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imageSequenceCurated: true,
    };
  },
  computed: {
    imageTypeIsVideo() {
      return this.imageType.toLowerCase().includes("video");
    },
    primaryMedia() {
      if (this.imageTypeIsVideo) {
        return this.getVideo(this.imageType);
      }

      return this.getImage(this.imageType);
    },
    secondaryMedia() {
      if (this.imageType === "ecomImages") {
        return this.getImage("flatlayImages");
      }

      if (this.product.handle === "bangle-set") {
        console.log(this.getImage("ecomImages"));
      }

      return this.getImage("ecomImages");
    },
  },
  methods: {
    getImage(imageType) {
      if (this.imageSequenceCurated) {
        const reference =
          this.getFirstReference(this.product[imageType]?.references.edges) ||
          this.getFirstReference(
            this.product["flatlayImages"]?.references.edges
          ) ||
          this.getFirstReference(this.product.images?.edges);

        return reference?.image || reference;
      }
      return this.getFirstReference(this.product.images?.edges);
    },
    getVideo(imageType) {
      const video = this.getFirstReference(
        this.product[imageType]?.references.edges
      );

      if (!video) {
        return this.getFirstReference(this.product.images?.edges);
      }

      return video;
    },
    getFirstReference(references) {
      if (!references) return;
      const nodes = references.map((reference) => reference.node);
      return nodes[0];
    },
  },
};
</script>
